import { useFormikContext } from 'formik';
import { WebsiteOutreachPoolInitialValues } from '../../types/WebsiteOutreachPoolInitialValues';

export function ResetFilterButton() {
    const formik = useFormikContext<WebsiteOutreachPoolInitialValues>();
    return (
        <button
            type="button"
            className="border border-blue-200 focus:border-blue-600 hover:border-blue-600 hover:bg-blue-100 p-2 px-3 rounded-md ml-2 align-middle mt-2 space-x-2"
            onClick={(event) => {
                formik.resetForm();
                formik.setFieldValue('filterToggle', true);
            }}
        >
            Reset Filter
        </button>
    );
}
